<template>
  <BaseModal>
    <div v-if="terminal" class="w-full">
      <div class="relative">
        <strong
          :class="
            terminal.provider === 'ADYEN'
              ? 'bg-lagon-700 text-lagon-50'
              : 'bg-amber-700 text-amber-50'
          "
          class="px-1 absolute top-0 right-0 py-px text-xs rounded inline-block"
        >
          {{ terminal.provider }}
        </strong>
        <BaseInput v-model="terminal.terminalId" label="Terminalid" />
        <BaseInput
          v-model="terminal.username"
          label="Användarnamn"
          class="mt-3"
        />
        <BaseInput v-model="terminal.password" label="Lösenord" class="mt-3" />
        <BaseInput
          v-if="terminal.provider === 'ADYEN'"
          v-model="terminal.displayName"
          label="Etikett"
          class="mt-3"
        />
      </div>
      <div>
        <ApolloQuery
          :query="require('../../graphql/Cashregisters.gql')"
          :variables="{
            where: { saloonId: terminal.saloonId, skip: 0, take: 200 },
          }"
        >
          <template
            slot-scope="{
              result: { loading, error, data, refetch },
              isLoading,
            }"
          >
            <!-- Loading -->
            <div v-if="isLoading" class="w-full pt-16 text-center">
              <b-spinner class="align-middle" />
            </div>

            <!-- Error -->
            <div v-else-if="error" class="error apollo">Ett fel inträffade</div>

            <!-- Result -->
            <div
              v-else-if="data && data.cashregisters"
              class="mt-3 result apollo"
            >
              <span
                class="block mb-1 text-sm font-semibold tracking-wide text-gray-900"
              >
                Terminalordning 1-9
              </span>
              <div
                v-for="c of data.cashregisters.items"
                :key="c.name"
                class="flex flex-col flex-wrap mt-1"
              >
                <div
                  class="block mb-1 text-sm font-semibold tracking-wide text-gray-900"
                >
                  <span>
                    {{ c.name }}
                  </span>
                  <span>
                    {{ c.companyName }}
                  </span>
                </div>
                <TerminalOrder :value="c" />
              </div>
            </div>

            <!-- No result -->
          </template>
        </ApolloQuery>
      </div>
    </div>
    <template #footer>
      <div class="flex justify-between">
        <button class="btn btn-danger" @click="remove">Ta bort</button>
        <div>
          <div>
            <button class="btn btn-default" @click="close">Stäng</button>
            <button class="btn btn-secondary" @click="save">Spara</button>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal'
import TerminalOrder from './TerminalOrder.vue'

export default {
  components: {
    BaseModal,
    TerminalOrder,
  },
  data() {
    return {
      terminal: null,
      loading: false,
      submitLoading: false,
      dirtyTerminalOperator: false,
    }
  },

  methods: {
    close() {
      this.$router.push({
        name: 'companydetails',
        params: { id: this.$route.params.id },
      })
    },

    async save() {
      try {
        this.submitLoading = true
        await this.$apollo.mutate({
          mutation: require('../../graphql/UpdateTerminal.gql'),
          variables: {
            data: {
              terminalId: this.terminal.terminalId,
              username: this.terminal.username,
              password: this.terminal.password,
              displayName: this.terminal.displayName,
            },
            id: this.$route.params.terminalId,
          },
        })

        this.$emit('refresh')
        this.$router.push({
          name: 'companydetails',
          params: { id: this.$route.params.id },
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.submitLoading = false
      }
    },

    async remove() {
      if (confirm('Är du säker att du vill ta bort terminalen?')) {
        try {
          this.submitLoading = true
          await this.$apollo.mutate({
            mutation: require('../../graphql/RemoveTerminal.gql'),
            variables: {
              id: this.$route.params.terminalId,
            },
          })

          this.$emit('refresh')
          this.$router.push({
            name: 'companydetails',
            params: { id: this.$route.params.id },
          })
        } catch (error) {
          console.log(error)
        } finally {
          this.submitLoading = false
        }
      }
    },
  },
  apollo: {
    terminal: {
      query: require('../../graphql/Terminal.gql'),
      variables() {
        return {
          id: this.$route.params.terminalId,
        }
      },
      fetchPolicy: 'no-cache',
      loadingKey: 'loading',
    },
  },
}
</script>
